module.exports = __webpack_public_path__ + "media/images/cover_report-e578c740dee31f40839dc109b00a97ab.png";